

import { PlatformModule } from '@angular/cdk/platform';
import { NgModule } from '@angular/core';

import { MwcWaveDirective } from './mwc-wave.directive';

@NgModule({
  imports: [PlatformModule],
  exports: [MwcWaveDirective],
  declarations: [MwcWaveDirective]
})
export class MwcWaveModule {}
